/*
 * This module is currently not being used. Initially the design included it for customer selection
 * during manual case creation. However, the customer listing API is not available, and would require
 * significant work to develop. We keep this module here to be used when that API is ready.
 */
import {
  FETCH_CUSTOMERS,
  FETCH_CUSTOMERS_FAIL,
  FETCH_CUSTOMERS_SUCCESS
} from '../../actions/cm/customers';

export const initialState = {
  isLoading: false,
  hasError: false,
  list: [],
  total: 0
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_CUSTOMERS:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case FETCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        list: payload.customers,
        total: payload.total
      };
    case FETCH_CUSTOMERS_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true
      };
    default:
      return state;
  }
}
